









import Vue from "vue";
import AppCard from "@/components/AppCard.vue";
import { mapGetters } from "vuex";
import Homepage from "@/components/Homepage.vue";
import { StateSearchApp } from "@/store/app/types_app";

export default Vue.extend({
  name: "ResultList",
  components: { Homepage, AppCard },
  computed: {
    ...mapGetters(["getApps", "getStateSearchApp"]),
    isLoading(): boolean {
      return this.getStateSearchApp === StateSearchApp.loading;
    },
  },
});
